// 后端仍可能返回旧业务名称，仅转换展示文案，避免改动接口字段和原始数据。
export function formatPointText (value) {
  return typeof value === 'string' ? value.replace(/积分/g, '浙豆宝') : value
}



// WEBPACK FOOTER //
// ./src/utils/pointText.js